module.exports = __webpack_public_path__ + "static/snap-desktop2-bd587079f1510c94b9c9e167066002ef.png";